
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({})
export default class IndexView extends Vue {
  @Prop({ type: String, default: '' }) leftText!: string
  @Prop({ type: String, default: '确认' }) text!: string
  @Prop({ type: Boolean, default: false }) disabled!: boolean

  handleLast() {
    this.$emit('left')
  }

  handleNext(e: any) {
    !this.disabled && this.$emit('confirm')
  }
}
